module.exports = __webpack_public_path__ + "b04f36f02b0a23b4d8509ec715bf8e6b.svg";